/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import copyButtonTemplate from './copy-button.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.copyButton', [])
    .directive('tkCopyButton', CopyButton)
    .name;

/*@ngInject*/
function CopyButton($compile, $templateCache) {

    var linker = function (scope, element) {

        var template = $templateCache.get(copyButtonTemplate);
        element.html(template);

        scope.isCopied = false;

        scope.clearCopy = function() {
            scope.isCopied = false;
        }
    
        scope.onTextCopied = function() {
            scope.isCopied = true;
        }

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        scope: {
            copyText: '='
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/copy-button.directive.js